// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__34z0g","productName":"Table_productName__vW1ct"};